module.exports = __webpack_public_path__ + "static/media/content-properties-icon.34d20aed.svg";